<c-container class="mt-5">
  <h2>Charity Payouts</h2>
  <app-charity-payouts [gameSetter]="{ gameP: activeGame, isCrossGame: false }"></app-charity-payouts>
</c-container>
